import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';

@Injectable({
  providedIn: 'root'
})
export class ClientgroupService {
  constructor(private httpClient: HttpClient) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + "/common/clientgroup"

  getModify(groupid): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/getmodify/${groupid}`);
  }
  getData(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/getdata`);
  }
  addClientGroup(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/addclientgroup`, payload);
  }
  modifyClientGroup(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/modifyclientgroup`, payload);
  }
  excelUploadFormat() {
    return this.httpClient.get(`${this.baseURL}/bulkuploadtempexcel`, { responseType: 'blob' });
  }

  getConfiguration(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/getconfiguration`);
  }

  uploadExcelFile(formData: FormData) {
    return this.httpClient.post(`${this.baseURL}/processexcel`, formData);
  }

  getExcelData() {
    return this.httpClient.post(`${this.baseURL}/getexcel`, {}, { responseType: 'blob' as 'json' });
  }
}
